import styled from 'styled-components';
import { mediaQueries, size, typography, colors } from '@everlywell/leaves';

export const MarkerModalTitle = styled.h2`
  ${typography.h3Text};
  margin-top: ${size.xs1}px;
  text-align: center;
  margin-bottom: ${size.xl2}px;
  ${mediaQueries.forTabletHorizontalUp} {
    margin-bottom: ${size.xl1}px;
  }
`;

export const MarkerContainer = styled.div`
  margin-left: 14px;
  margin-bottom: ${size.xl2}px;

  ${mediaQueries.forTabletVerticalUp} {
    margin-left: 88px;
  }

  ${mediaQueries.forTabletHorizontalUp} {
    margin-left: 24px;
  }
`;

export const MarkerTitleContainer = styled.div`
  display: flex;
  margin-bottom: ${size.sm}px;
`;

export const MarkerIcon = styled.img`
  height: ${size.lg}px;
  width: ${size.lg}px;
  margin-right: ${size.sm}px;
`;

export const MarkerTitle = styled.h3`
  font-size: 18px;
  line-height: ${size.lg}px;
  letter-spacing: 0.45px;
`;

export const MarkerList = styled.ul`
  display: flex;
  flex-wrap: wrap;
`;

export const Marker = styled.li`
  margin-bottom: ${size.md}px;
  color: ${colors.gray4};
  margin-left: 18px;
  font-weight: ${typography.weight.book};
  flex: 0 1 calc(50% - 18px);
  ${mediaQueries.forTabletHorizontalUp} {
    flex: 0 1 calc(33% - 18px);
  }
`;
